import { React, Component, Config, Container, Link, _ } from "utils";

import Slider from "./elements/slider";
import ChatView from "./elements/chat";
import AboutView from "./elements/about";
import WhyUsView from "./elements/whyus";

import GallerySlider from "./galleryslider";
import { withRouter } from "react-router-dom";
import { FairStore, SelectedPavilionStore, App } from "model";
import PointOfInterest from "./pointofinterest";

import "./elements/offers.less";

const factories = {
  person: Image,
  decoration: Image,
  offers: Offers,
  gallery: Gallery,
  chat: Chat,
  about: About,
  whyus: WhyUs,
};

function Chat(data, stand) {
  return <ChatView data={data} stand={stand} />;
}

function About(data, stand) {
  return <AboutView data={data} stand={stand} />;
}

function WhyUs(data, stand) {
  return <WhyUsView data={data} stand={stand} />;
}

function Background({ data }) {
  var panels = [];

  for (var i = 1; i <= data.standType.standFeatureCount; i++) {
    panels.push(<div key={i} className="panel"></div>);
  }

  var style = {
    backgroundColor: data.backgroundColor,
  };

  var bp = null;

  if (SelectedPavilionStore.isActive(data.slug)) {
    var bi = data.backgroundImageUrl;

    if (bi != null) {
      var styleImage = {
        backgroundImage: App.url(bi),
      };
      bp = <div className="background-panel" style={styleImage}></div>;
    }
  }

  return (
    <div className="background" style={style}>
      {bp}
      <div className="background-shadow-top"></div>
      {panels}
      <div className="background-shadow-bottom"></div>
    </div>
  );
}

function Gallery(data, stand) {
  var element = data.standElement;

  var pavilion = SelectedPavilionStore.getSelectedPavilion();
  var gallery = App.activityUrl(pavilion, stand, "gallery");

  var style = {
    width: element.width,
    height: element.height,
  };

  var variation = App.filename(element.imageUrl);

  return (
    <div className={variation}>
      <GallerySlider data={element} stand={stand} />
      <PointOfInterest to={gallery} name={element.standFeature.name} />
      <div className="frame">
        <img src={element.imageUrl} style={style} />
      </div>
    </div>
  );
}

function Image(data) {
  return <img src={data.standElement.imageUrl} />;
}

function Offers(data, stand) {
  var offers = stand.standOffers;
  var src = data.standElement.imageUrl;

  var pavilion = SelectedPavilionStore.getSelectedPavilion();
  var url = App.activityUrl(pavilion, stand, "offers");

  var offersToShow = [];

  offers.map((item, key) => {
    if (item.offerPavilion === pavilion.id) {
      offersToShow.push(item);
    }
  });

  let title = stand.title === "EduCentar" ? _("Educations") : _("Jobs");

  return (
    <div className="box">
      <div className="content">
        <Slider data={offersToShow} />
        <div className="title">
          <h4>{title}</h4>
        </div>
      </div>
      <div className="frame">
        <img src={src} alt={title} />
        <PointOfInterest to={url} name={data.standElement.standFeature.name} />
      </div>
    </div>
  );
}

function Element({ data, children, history }) {
  let style = {
    top: data.top,
    left: data.left,
    zIndex: data.weight,
  };

  const type = data.standElement.standFeature.type;
  let css = ["element", type];
  if (["offers", "gallery", "about", "whyus"].includes(type))
    css.push("hoverable");

  return (
    <div
      className={css.join(" ")}
      style={style}
      onClick={(event) => {
        let linkElement = $(event.target)
          .closest(".element")
          .find(".point-of-interest")
          .find("span[data-link]")[0];
        if (linkElement) history.push($(linkElement).data("link"));
      }}
    >
      {children}
    </div>
  );
}

function Elements({ data, stand, render, history }) {
  var elements = [];

  if (render) {
    elements = data.map(function(item, index) {
      var factory = factories[item.standElement.standFeature.type];
      var view = null;

      if (factory) {
        view = factory(item, stand);
      }

      return (
        <Element key={index} data={item} history={history}>
          {view}
        </Element>
      );
    });
  }

  return <div className="elements">{elements}</div>;
}

class StandView extends Component {
  static getStores() {
    return [SelectedPavilionStore];
  }

  static calculateState(state, props) {
    var { data } = props;

    return {
      active: SelectedPavilionStore.isActive(data.slug),
    };
  }

  render() {
    var { data } = this.props;
    var { active } = this.state;

    if (data) {
      var css = ["stand", data.slug];
      var render = active;

      console.log("STAND DATA", data.slug, render);

      return (
        <div className={css.join(" ")} data-slug={data.slug}>
          <Background data={data} />
          <div className="ceiling"></div>
          <div className="floor"></div>
          <Elements
            data={data.standToStandElements}
            stand={data}
            render={render}
            history={this.props.history}
          />
          <div className="post">
            <div className="post-header"></div>
            <div className="post-footer"></div>
            <div className="post-shadow-bottom-right"></div>
            <div className="post-shadow-bottom-left"></div>
            <div className="post-shadow-top-right"></div>
            <div className="post-shadow-top-left"></div>
            <div className="post-body"></div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const Stand = Container.create(StandView, { withProps: true });
export { Stand };



// WEBPACK FOOTER //
// ./src/modules/components/stand.js